module.exports = __webpack_public_path__ + "img/vendor-icon-dj.331df79b.png";